import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { RoleDto } from '@asset-metrix/portal-gateway-client-js';
import { SingleSelect } from '@asset-metrix/portal-ui';
import { useShallow } from 'zustand/react/shallow';

import { useUserRolesData } from '../../api/portalGateway/role';
import { useTenantInfoData } from '../../api/portalGateway/tenantInfo';
import { useStore } from '../../store';

function userRoleToOption(item: RoleDto) {
  return {
    label: item.displayName,
    value: item.id,
  };
}

export function InvestorSelector({ className }: { className?: string }) {
  const { '*': slug } = useParams();
  const navigate = useNavigate();
  const [activeUserRole, setActiveUserRole] = useStore(
    useShallow((state) => [state.activeUserRole, state.setActiveUserRole])
  );

  const { data: userRolesData } = useUserRolesData();
  const userRoles = userRolesData.items;
  const options = userRoles.map(userRoleToOption);
  const {
    data: { roleSelectLabel },
  } = useTenantInfoData();

  return options.length > 1 ? (
    <SingleSelect
      className={className}
      label={roleSelectLabel}
      clearable={false}
      variant="ghost"
      data={options ?? []}
      onChange={(newValue) => {
        const newInvestor = userRoles?.find((item) => item.id === newValue);
        if (newInvestor != null) {
          setActiveUserRole(newInvestor);
          navigate(`/p/${encodeURIComponent(newInvestor.id)}/${slug}`);
        }
      }}
      value={activeUserRole?.id ?? null}
    />
  ) : null;
}
